/**
 * @fileoverview Logo Component
 * @description Alaska Airlines branded logo for sidebar
 */

import React from 'react';
import './Logo.css';
import alaskaLogo from '@/assets/images/Alaska-Airlines-Logo.png';

const Logo = ({ collapsed = false }) => {
  return (
    <div className={`logo-container ${collapsed ? 'collapsed' : ''}`}>
      <div className="logo-icon">
        <img src={alaskaLogo} alt="Alaska Airlines Logo" />
      </div>
      {!collapsed && (
        <div className="logo-text">
          <span className="logo-title">Alaska Airlines</span>
          <span className="logo-subtitle">QE Portal</span>
        </div>
      )}
    </div>
  );
};

export default Logo;
